/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Transaction server Services 
 * These services provide APIs to interact with transaction
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
/**
 * OrderDownloadApi - axios parameter creator
 * @export
 */
export const OrderDownloadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Download an order export file by export ID.
         * @param {string} storeId The store identifier.
         * @param {string} exportId The export ID from the order export REST API call.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeStoreIdOrderDownloadByExportIdExportIdGet: async (storeId: string, exportId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('storeStoreIdOrderDownloadByExportIdExportIdGet', 'storeId', storeId)
            // verify required parameter 'exportId' is not null or undefined
            assertParamExists('storeStoreIdOrderDownloadByExportIdExportIdGet', 'exportId', exportId)
            const localVarPath = `/store/{storeId}/order_download/byExportId/{exportId}`
                .replace(`{${"storeId"}}`, String(storeId))
                .replace(`{${"exportId"}}`, String(exportId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderDownloadApi - functional programming interface
 * @export
 */
export const OrderDownloadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderDownloadApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Download an order export file by export ID.
         * @param {string} storeId The store identifier.
         * @param {string} exportId The export ID from the order export REST API call.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeStoreIdOrderDownloadByExportIdExportIdGet(storeId: string, exportId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeStoreIdOrderDownloadByExportIdExportIdGet(storeId, exportId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrderDownloadApi - factory interface
 * @export
 */
export const OrderDownloadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderDownloadApiFp(configuration)
    return {
        /**
         * 
         * @summary Download an order export file by export ID.
         * @param {string} storeId The store identifier.
         * @param {string} exportId The export ID from the order export REST API call.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeStoreIdOrderDownloadByExportIdExportIdGet(storeId: string, exportId: string, options?: any): AxiosPromise<object> {
            return localVarFp.storeStoreIdOrderDownloadByExportIdExportIdGet(storeId, exportId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderDownloadApi - object-oriented interface
 * @export
 * @class OrderDownloadApi
 * @extends {BaseAPI}
 */
export class OrderDownloadApi extends BaseAPI {
    /**
     * 
     * @summary Download an order export file by export ID.
     * @param {string} storeId The store identifier.
     * @param {string} exportId The export ID from the order export REST API call.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderDownloadApi
     */
    public storeStoreIdOrderDownloadByExportIdExportIdGet(storeId: string, exportId: string, options?: any) {
        return OrderDownloadApiFp(this.configuration).storeStoreIdOrderDownloadByExportIdExportIdGet(storeId, exportId, options).then((request) => request(this.axios, this.basePath));
    }
}
